import { Chip } from '@mui/material';
import type { ICellRendererParams } from 'ag-grid-enterprise';

import type { ResponseActionSummaryDTO } from './MsDefenderIntegration.types';

const getResponseActionStatusColor = (
  status: string
): 'success' | 'error' | 'warning' | 'default' => {
  switch (status.toLowerCase()) {
    case 'completed':
      return 'success';
    case 'error':
    case 'failed':
      return 'error';
    case 'skipped':
      return 'warning';
    default:
      return 'default';
  }
};

export const renderResponseActionStatusCell = ({
  value
}: ICellRendererParams<ResponseActionSummaryDTO, string>) => {
  if (!value) return null;
  return (
    <Chip
      size="small"
      label={value}
      color={getResponseActionStatusColor(value)}
      sx={{ textTransform: 'capitalize', fontSize: '0.75rem' }}
    />
  );
};
